var map = {
	"./acrysil-logo.png": "e4oB",
	"./amara-logo.png": "fvVJ",
	"./astral-logo.png": "DaqB",
	"./atul-logo.png": "du5N",
	"./cera-logo.png": "7ygC",
	"./finolex-logo.png": "Ge6k",
	"./gulshan-logo.png": "FXAk",
	"./superhouse-logo.png": "eJaO",
	"./suprajit-logo.png": "ZuTl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ADmC";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\-logo\.png$
// module id = ADmC
// module chunks = 1